export const userTypes = {
  ADMINISTRADOR: 0,
  MENTOR: 1,
  MENTORADO: 2,
  MENTOREMENTORADO: 3,
};

export const getByNumber = [
  'ADMINISTRADOR', 'MENTOR', 'MENTORADO', 'MENTOREMENTORADO',
];